import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'

import { AddAttributionEntryForm } from '@/components/forms/AddAttributionEntryForm/AddAttributionEntryForm'
import { AddAttributionEntryFormFields } from '@/components/forms/AddAttributionEntryForm/AddAttributionEntryFormFields'

export interface AddAttributionEntryModalProps extends DialogProps {}

export const AddAttributionEntryModal: React.FC<AddAttributionEntryModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddAttributionEntryForm defaultValues={{ input_type: 'attributions' }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Add Attribution Entry</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <AddAttributionEntryFormFields />
                </div>
                <DialogFooter>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddAttributionEntryForm>
      </DialogContent>
    </Dialog>
  )
}
